var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-alert',{attrs:{"type":_vm.typeClass,"dismissible":""}},[_vm._v(" "+_vm._s(_vm.notification.message)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }